import { hockeyPositions, type HockeyPosition, type StickHand } from '@stm/contracts';
import type { TranslationKey } from '@stm/i18n';

export const hockeyPositionLabelKeys: Readonly<Record<HockeyPosition, TranslationKey>> = {
  goalkeeper: 'hockeyProfile.position.goalkeeper',
  defender: 'hockeyProfile.position.defender',
  forward: 'hockeyProfile.position.forward',
};

export const stickHandLabelKeys: Readonly<Record<StickHand, TranslationKey>> = {
  left: 'hockeyProfile.stickHand.left',
  right: 'hockeyProfile.stickHand.right',
};

/** Adds or removes a position, keeping the fixed order goalkeeper, defender, forward and no repeats. */
export function togglePosition(
  current: readonly HockeyPosition[],
  position: HockeyPosition,
  selected: boolean,
): HockeyPosition[] {
  const next = new Set(current);
  if (selected) next.add(position);
  else next.delete(position);
  return hockeyPositions.filter((candidate) => next.has(candidate));
}
